/**
 * Tag state refs.
 *
 * `activeTagFilter` is persisted to `localStorage` under
 * `wwm-gvg-active-tag-filter-v1` so a returning user lands on the same
 * chip-strip filter they last picked.
 *
 * `playerTags` is the guild's tag catalog — populated by `fetchPlayerTags`
 * (called from the planner's `onMounted` and again whenever a tag mutation
 * might have changed the set). The `Board` query already returns each
 * player's tags inline, so a dedicated catalog fetch is only needed to
 * populate the toolbar's chip strip and the `OfficerManagementPanel`'s
 * tag editor.
 */
import { ref, type Ref } from 'vue'

import { useLocalStorage } from '@/shared/composables'
import type { PlayerTag } from '../../types'

export interface TagStateApi {
  readonly playerTags: Ref<ReadonlyArray<PlayerTag>>
  readonly activeTagFilter: Ref<string | null>
}

export function useTagState(): TagStateApi {
  const playerTags = ref<ReadonlyArray<PlayerTag>>([])
  const activeTagFilter = useLocalStorage<string | null>(
    'wwm-gvg-active-tag-filter-v1',
    null,
  )

  return { playerTags, activeTagFilter }
}
